import React from 'react';

interface SupportSuggestedArticlesLayoutProps {
    element: any
}

const SupportSuggestedArticlesLayout: React.FC<SupportSuggestedArticlesLayoutProps> = (element) => {

    const handleSuggestedArticles = (items: any) => {
            if(items){
                return Array.isArray(items) && items.map((item, index) =>(
                    <li className="mt-4" key={index}>
                        <a href={window.location.origin + "/support/" + item?.attributes?.slug} className="arrowed-link light-gray" style={{textDecoration: 'none'}}>
                            {item?.attributes?.Name}
                            <i className="icon-angle-right"></i>
                        </a>
                    </li>
                ))
            }
        }
    
    return (
      <>
        <div className="suggested-articles light-gray-bg margin-spacer-top">
            <div className="container-fluid py-5">
				<h3 className="text-center mb-5 font-medium">{element?.element?.SectionTitle}</h3>
				<ul className="text-center barlow-font light-gray remove-bullet">
                    {handleSuggestedArticles(element?.element?.Articles?.data)}
                </ul>
			</div>
		</div>
      </>
    );
};

export default SupportSuggestedArticlesLayout;